import { Response } from "@angular/http";
import { Operation } from "./operation";
import { Observable } from "rxjs/Observable";
import { ChangeQItem } from "../item";
import { IOperation } from "../operation.interface";

export class SubResourceOperation extends Operation implements IOperation {

    transactionType = "SubResourceOperation";
    parentEntity = "job";

    post(item?: ChangeQItem): Observable<Response> {

        item = item || this.item;

        return this.getRestService().postAccountObjectSubResource(
            item.account,
            this.parentEntity,
            item.parentId,
            item.entity,
            item.data
        );
    }

    patch(item?: ChangeQItem): Observable<Response> {

        item = item || this.item;

        return this.getRestService().patchAccountObjectSubResource(
            item.account,
            this.parentEntity,
            item.parentId,
            item.entity,
            item.id,
            item.data,
            item.version
        );
    }

    delete(item?: ChangeQItem): Observable<Response> {

        item = item || this.item;

        return this.getRestService().deleteAccountObjectByIdSubResource(
            item.account,
            this.parentEntity,
            item.parentId,
            item.entity,
            item.id
        );
    }

    setParentEntity(entity: string): void {
        this.parentEntity = entity;
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/operations/sub-resource-operation.ts